class CheckCalculation {
    constructor(controller) {
        this.controller = controller
    }

    isSensorAllowed() {
        if(this.controller == undefined) {
            return true
        }
        if(this.controller.slaveSensorTechnologie !== null) {
            return true;
        } else {
            return false
        }
    }

    isInputDeviceAllowed() {
        if(this.controller == undefined) {
            return true
        }
        if(this.controller.slaveInputTechnologie !== null) {
            return true;
        } else {
            return false
        }
    }

    removeNotWorkDevices(devices) {
        if(!this.isInputDeviceAllowed()) {
            let inputItems = devices.filter(obj => obj.typeCategory == 3) 
            for(let input of inputItems) {
                let index = devices.findIndex(obj => obj == input)
                devices.splice(index,1);
            }
        }
        if(!this.isSensorAllowed()) {
            let inputItems = devices.filter(obj => obj.typeCategory == 2) 
            for(let input of inputItems) {
                let index = devices.findIndex(obj => obj == input)
                devices.splice(index,1);
            }
        }
        return devices;
    }
}

export default CheckCalculation